import { Component, Input, Output,EventEmitter } from '@angular/core';
import { ContactsProvider } from '../../providers/contacts/contacts';
import { EWalletRecipient } from '../../model/models/wallet/wallet';
import { LoggerEvent, LoggerProvider } from '../../providers/logger/logger';
import { RouteProvider } from '../../providers/route/route';
import { OpenNativeSettings } from "@ionic-native/open-native-settings";
import { Platform } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { WalletProvider } from '../../providers/wallet/wallet';

@Component({
  selector: 'rmt-contacts',
  templateUrl: 'rmt-contacts.html'
})
export class RmtContactsComponent {

  /*
  <rmt-contacts (contactSelectEmitter) = "onContactSelected($event)" (contactsLoadedEmitter)="onContactsLoaded($event)" (contactsSearchCompletedEmitter)="onContactsSearchComplted($event)"
  [groupHeaderTitle]="'Wallet Contacts'" [searchString]="searchString"></rmt-contacts>
  */

  /*
    This one is to set the list group header
  */
  @Input() private groupHeaderTitle: string;

  /*
    This one is search the contacts if we have search bar input on the page. search bar input model can be bind to this.
  */
  @Input() private searchString: string;
  /*
    This one will get trigger when user select the contact
  */
  @Output() contactSelectEmitter = new EventEmitter<any>();
  /*
    This one will get trigger once user gave access to contacts and the contacts are loaded.
   */
  @Output() contactsLoadedEmitter: EventEmitter<any> = new EventEmitter<any>();
  /*
    This one will trigger once the search is completed with the give searchString.
   */
  @Output() contactsSearchCompletedEmitter = new EventEmitter<any>();
  contactsLoading:boolean = false
  contatcs = [];
  contatcsMasterCopy = [];
  private readonly contactsDisplayLimit = 30; // limit contact per load to prevent performance issue
  private contactsDisplaySource = [];
  isContactsSynched: boolean = false;
  isAccessToContactsGiven:boolean = false;
  isOpeningNativeSettings:boolean = false;
  onResume;
  searchInputMaxLength = 20;
  constructor(private contactsProvider: ContactsProvider,
              private nativeSettings: OpenNativeSettings,
              private platform: Platform,
              private translate: TranslateService,
              private routeProvider: RouteProvider,
              private walletProvider: WalletProvider) {
    
  }
  
  async ngOnInit() {
    this.isAccessToContactsGiven = await this.contactsProvider.isAccessToContactsGiven();
    this.accessAndParseDeviceContacts();
  }

  ngOnChanges(){
    if(this.searchString && this.searchString.trim(). length > 0){
      this.onSearchStringChanged();
    }
  }

  async accessAndParseDeviceContacts(openNativeSettings =true, forceSyncContact = false){
    if (!forceSyncContact && this.walletProvider.phoneContactsPreload) {
      // Wallet home's background read is still running, so wait for it instead of reading the contacts again
      this.contactsLoading = true;
      await this.walletProvider.phoneContactsPreload;
    }
    // Reuse contacts already read here before, or preloaded by wallet home
    const deviceContacts = this.contactsProvider.getDeviceContacts() || this.walletProvider.getEWalletContacts();
    if(!forceSyncContact && deviceContacts !== null){
      this.contatcsMasterCopy = deviceContacts;
      this.setDisplayedContacts(this.contatcsMasterCopy);
      this.setIsContactsSynched(true);
      this.contactsLoading = false;
      this.emitContactsLoadedEvent();
      return;
    }
    this.contactsLoading = true;
    this.contactsProvider.findContacts(this.contactsProvider.reasons.syncContacts, ['displayName', 'phoneNumbers'], { hasPhoneNumber: true, multiple: true })
    .then((contactsList: any) => {
      if (contactsList) {
        LoggerProvider.info(this, 'Sync contacts: got contacts ' + contactsList.length);
        this.parseContactList(contactsList);
      }
      else
        LoggerProvider.info(this, 'Sync contacts: access to contacts not allowed');
      this.contactsLoading = false;
      LoggerProvider.info(this, 'Sync contacts: parsed contacts');
    }).catch((error)=>{
      LoggerProvider.warning(this, LoggerEvent.PageException, 'Sync contacts: Failed to load contacts', error);
      this.contactsLoading = false;
      // on android error code is 20 when didn't allow permission
      if(openNativeSettings &&( (!this.isAccessToContactsGiven) || forceSyncContact) )// to prevent go in infinite loop
        this.showContactsPermissionError();
      this.contactsProvider.setAccessToContactsDenied();
      this.isAccessToContactsGiven = false;
      this.setIsContactsSynched(false);
    })
  }

  parseContactList(contactsList ) {
    const start = new Date().getTime();
    LoggerProvider.info(this, 'Parse contacts: start');
    try {
      if(this.onResume)
        this.onResume.unsubscribe();
      this.contatcsMasterCopy = this.walletProvider.mapPhoneContacts(contactsList);
      LoggerProvider.info(this, 'Parse contacts: parsed all contacts (' + (new Date().getTime() - start) + 'ms)');
      this.setDisplayedContacts(this.contatcsMasterCopy);
      LoggerProvider.info(this, 'Parse contacts: set contacts (' + (new Date().getTime() - start) + 'ms)');
      this.contactsProvider.setDeviceContacts(this.contatcsMasterCopy);
      this.contactsProvider.setAccessToContactAllowed();
      this.isAccessToContactsGiven = true;
      this.setIsContactsSynched(true);
      LoggerProvider.info(this, 'Parse contacts: assign contacts (' + (new Date().getTime() - start) + 'ms)');
      this.emitContactsLoadedEvent();
    } catch (ex) {
      LoggerProvider.error(this, ex, 'Failed to parse contacts (' + (new Date().getTime() - start) + 'ms)');
    }
    LoggerProvider.info(this, 'Parse contacts: finished (' + (new Date().getTime() - start) + 'ms)');
  }

  setIsContactsSynched(isContactsSynched:boolean){
    this.isContactsSynched = isContactsSynched;
  }

  showContactsPermissionError(){
    let subtitleKey = 'page.eWalletPage.requestDetails.accessContactsBodyApple';
    if(this.platform.is('android')){
      subtitleKey = 'page.eWalletPage.requestDetails.accessContactsBodyAndroid';
    }
    this.isOpeningNativeSettings = true;
    const params = { title: this.translate.instant('page.eWalletPage.requestDetails.accessContactsHeader'),
      subtitle: this.translate.instant(subtitleKey),
      secondaryButtonText:  this.translate.instant('global.genericCancelButton'),
      primaryButtonText : this.translate.instant('page.eWalletPage.requestDetails.accessContactsButton'),
      primaryAction:  this.openApplicationDetails.bind(this),
      showSecondaryButton : true
    };
    this.routeProvider.openActionSheet(this.routeProvider.pages.ModalAlertPage, params,null);
  }

  openApplicationDetails(){
    this.nativeSettings.open('application_details').then((data)=>{
      if(!this.onResume){
        this.onResume=this.platform.resume.subscribe(()=>{
          this.accessAndParseDeviceContacts(false,true);
          this.onResume.unsubscribe();
          this.onResume = undefined;
        });
      }
      // this to fix issue fo ios when user go to settings and enable sync and reopen the app
      // still see sync contacts message
      // if user did not allow it then will throw error in sync and disable auto sync
      if(this.platform.is('ios')){
        this.contactsProvider.setAccessToContactAllowed();
      }
    }).catch((error)=>{
      LoggerProvider.exception(this, error, LoggerEvent.ProviderException, 'Failed to open native settings');
    })
  }

  onContactSelected(contact){
    if(this.contactSelectEmitter){
      this.contactSelectEmitter.emit(contact);
    }
  }

  emitContactsLoadedEvent(){
    if(this.contactsLoadedEmitter){
      this.contactsLoadedEmitter.emit(this.contactsDisplaySource);
    }
  }

  emitContactsSearchCompltedEvent(){
    if(this.contactsSearchCompletedEmitter) {
      this.contactsSearchCompletedEmitter.emit(this.contactsDisplaySource);
    }
  }

  onSearchStringChanged(){
    if (this.searchString.length === 0) {
      this.contactsLoading = true;
      this.setDisplayedContacts(this.contatcsMasterCopy);
      window.setTimeout(()=> this.contactsLoading = false, 200)
      this.emitContactsSearchCompltedEvent();
      return;
    }
    if(this.searchString.length > this.searchInputMaxLength){
      this.searchString = this.searchString.substring(0, this.searchInputMaxLength);
    }
    this.setDisplayedContacts(this.contatcsMasterCopy.filter((item) => {
      return (item.FullNameFromDevice.toLowerCase().indexOf(this.searchString.toLowerCase()) > -1 || item.PhoneNumber.toLowerCase().indexOf(this.searchString.toLowerCase()) > -1);
    }));
    this.emitContactsSearchCompltedEvent();
  }

  // Sets the full/filtered source and renders only the first page. The rest is appended on scroll
  // via loadMoreContacts(), so we never mount the whole address book at once.
  private setDisplayedContacts(source) {
    this.contactsDisplaySource = source || [];
    this.contatcs = this.contactsDisplaySource.slice(0, this.contactsDisplayLimit);
  }

  // True while there are more contacts to page in (drives the ion-infinite-scroll).
  get hasMoreContacts(): boolean {
    return this.contatcs.length < this.contactsDisplaySource.length;
  }

  // Appends the next page of contacts when the user scrolls near the bottom.
  loadMoreContacts(infiniteScroll?: any) {
    const nextCount = this.contatcs.length + this.contactsDisplayLimit;
    this.contatcs = this.contactsDisplaySource.slice(0, nextCount);
    if (infiniteScroll)
      infiniteScroll.complete();
  }
}



// WEBPACK FOOTER //
// ./src/components/rmt-contacts/rmt-contacts.ts